import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {NgForm} from '@angular/forms';
import {MatRadioChange} from '@angular/material/radio';

@AcDialog({
  width: 400
})
@Component({
  selector: 'cac-profiles-dialog',
  templateUrl: './cac-profiles-dialog.component.html',
  styleUrls: ['./cac-profiles-dialog.component.scss'],
})
export class CacProfilesDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('cacProfileDialog') cacProfileDialog: NgForm;
  cacProfile;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {
    this.cacProfile = dialogConfig.dialogData;
    this.cacProfile.limitType = dialogConfig.dialogData.totalLimit > 0 ? 'global' : 'limitByDirection';
    this.dialogConfig.submitButtonDisabled = true;
  }

  ngOnInit(): void {
  }

  onLimitTypeChange(type: any): void {
    if (type instanceof MatRadioChange) {
      if (type.value === 'global') {
        this.cacProfile.incomingLimit = null;
        this.cacProfile.outgoingLimit = null;
      } else {
        this.cacProfile.totalLimit = null;
      }
    }
  }

  ngAfterViewInit(): void {
    this.cacProfileDialog.form.statusChanges.subscribe(() => {
      this.dialogConfig.submitButtonDisabled = !this.cacProfileDialog.form.valid;
    });
  }

}
